import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VRow, [_vm._l(_vm.filteredEditCols, function (col, index) {
    return _c(VCol, {
      key: index,
      staticClass: "my-2",
      attrs: {
        "cols": "4"
      }
    }, [_c(VTextField, {
      attrs: {
        "label": col,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": "auto",
        "autocomplete": "off",
        "clearable": ""
      },
      model: {
        value: _vm.editCols[col],
        callback: function ($$v) {
          _vm.$set(_vm.editCols, col, $$v);
        },
        expression: "editCols[col]"
      }
    })], 1);
  }), _c(VCol, {
    staticClass: "my-2",
    attrs: {
      "cols": "4"
    }
  }, [_c(VAutocomplete, {
    staticClass: "mb-1 mt-1",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.table.application'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.applications,
      "filter": _vm.filterItems,
      "auto-select-first": "",
      "item-text": "title",
      "item-value": "id",
      "clearable": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }]),
    model: {
      value: _vm.editCols.applicationId,
      callback: function ($$v) {
        _vm.$set(_vm.editCols, "applicationId", $$v);
      },
      expression: "editCols.applicationId"
    }
  })], 1), _c(VCol, {
    staticClass: "my-2",
    attrs: {
      "cols": "4"
    }
  }, [_c(VAutocomplete, {
    staticClass: "mb-1",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.table.originator'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.originators,
      "filter": _vm.filterItems,
      "return-object": "",
      "auto-select-first": "",
      "item-text": "title",
      "item-value": "id",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        return _vm.updateOriginatorId(_vm.editCols);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }]),
    model: {
      value: _vm.editCols.originator,
      callback: function ($$v) {
        _vm.$set(_vm.editCols, "originator", $$v);
      },
      expression: "editCols.originator"
    }
  })], 1), _c(VCol, {
    staticClass: "my-2",
    attrs: {
      "cols": "4"
    }
  }, [_c(VAutocomplete, {
    staticClass: "mb-1",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.deviceType'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.deviceTypes,
      "filter": _vm.filterItems,
      "auto-select-first": "",
      "item-text": "title",
      "item-value": "id",
      "clearable": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }]),
    model: {
      value: _vm.editCols.deviceTypeId,
      callback: function ($$v) {
        _vm.$set(_vm.editCols, "deviceTypeId", $$v);
      },
      expression: "editCols.deviceTypeId"
    }
  })], 1), _c(VCol, {
    staticClass: "my-2",
    attrs: {
      "cols": "4"
    }
  }, [_c(VSwitch, {
    staticClass: "shrink mx-0 my-0",
    attrs: {
      "color": _vm.color,
      "value": true,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.otaaAbp')
    },
    on: {
      "change": function ($event) {
        return _vm.updateOtaa($event, _vm.editCols);
      }
    },
    model: {
      value: _vm.editCols.otaa,
      callback: function ($$v) {
        _vm.$set(_vm.editCols, "otaa", $$v);
      },
      expression: "editCols.otaa"
    }
  })], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };